<template>
  <CreateEditCompanyModal
    v-if="showCreateEditCompanyModal"
    :companyId="companyIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Empresas</h4>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-dark"
          title="Cadastrar Empresa"
          @click="createEditCompany()"
        >
          Cadastrar Empresa
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListCompanies
      v-else
      :companies="companies"
      @createEditCompany="createEditCompany"
    />
  </div>
</template>

<script>
import CreateEditCompanyModal from '@/components/ethos/companies/CreateEditCompanyModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListCompanies from '@/components/ethos/companies/ListCompanies.vue'

export default {
  name: 'Companies',

  components: {
    CreateEditCompanyModal,
    LoadingData,
    ListCompanies,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateEditCompanyModal: false,
      companies: [],
      companyIdSelected: null,
    }
  },

  methods: {
    async getCompanies() {
      try {
        this.companies = await this.$store.dispatch('getCompanies')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditCompany(companyId) {
      this.companyIdSelected = companyId || null
      this.showCreateEditCompanyModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getCompanies()
      }
      this.showCreateEditCompanyModal = false
    },
  },

  mounted() {
    this.getCompanies()
  },
}
</script>
